import React, { useRef, useState } from 'react'
import Map from '../map/Map'
import UseMapPageLoad from '../../hooks/map-page/UseMapPageLoad';
import LoadDialog from '../../components/load-dialog/LoadDialog';
import Disclaimer from '../../widgets/custom/dialog/Disclaimer';

import { ShowReportsContextProvider } from '../../hooks/context/ShowReportsContext';
import { ShowMapContextProvider } from '../../hooks/context/ShowMapContext';
import Reports from '../../widgets/custom/reports/Reports';
const AppPage = () => {
  const mapDiv = useRef(null);

  const [portal,oauthChecked,view,viewReady]=UseMapPageLoad(mapDiv)

  if (oauthChecked) {
  return (
    <>
    <ShowMapContextProvider>
    <ShowReportsContextProvider>
      {!viewReady?<LoadDialog load={!viewReady} message="Map loading..."></LoadDialog>:""}
      {viewReady&&<Disclaimer></Disclaimer>}
      <Map data={{portal:portal,view:view,viewReady:viewReady}} ref={mapDiv}></Map>
      {viewReady&&<Reports view={view}></Reports>}
  </ShowReportsContextProvider>
  </ShowMapContextProvider>
    </>
  )
}else{
  return <></>
}
}

export default AppPage